import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { FirstTimeUserSetupComponent } from './first-time-user-setup/first-time-user-setup.component';
import { AnonymousGuard } from '../core/guards/anonymous.guard';

const routes: Routes = [
  {
    path: 'login',
   canActivate: [AnonymousGuard],
    component: LoginComponent,
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
  {
    path: 'first-time-user-setup',
    component: FirstTimeUserSetupComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
